import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

export class InterviewSlider {
  constructor() {
    const slider = document.querySelector('.js-interview_slider')
    if (!slider) return

    const swiper = new Swiper(slider, {
      modules: [Navigation],
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      setWrapperSize: true,
      slidesPerView: 1.2, // スマホ初期値
      spaceBetween: 16, // スマホ用余白
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2.2,
        },
        1280: {
          slidesPerView: 3.2,
        },
      },
    })
  }
}
